export const loadFavoriteProviders = (options) => ({
  storeId: 'favorite-providers-' + options.clientId,
  type: 'DASHBOARD_FAVORITE_PROVIDERS',
  request: {
    url: '/v2/my/providers/favorites',
    method: 'GET',
    params: {
      clientId: options.clientId,
    },
  },
});

export const loadProviderTopDx = (options) => ({
  storeId: 'analytics-provider-topdx-' + options.providerId,
  type: 'DASHBOARD_FAVORITE_PROVIDER_ANALYTICS_DX',
  request: {
    url: 'v2/analytics/providers/topdx',
    method: 'GET',
    params: {
      provider_id: options.providerId,
      limit: 3,
    },
  },
});

export const loadProviderTopPx = (options) => ({
  storeId: 'analytics-provider-toppx-' + options.providerId,
  type: 'DASHBOARD_FAVORITE_PROVIDER_ANALYTICS_PX',
  request: {
    url: 'v2/analytics/providers/toppx',
    method: 'GET',
    params: {
      provider_id: options.providerId,
      limit: 3,
    },
  },
});

export const loadProviderTopServiceLines = (options) => ({
  storeId: 'analytics-provider-topservicelines-' + options.providerId,
  type: 'DASHBOARD_FAVORITE_PROVIDER_ANALYTICS_TOP_SERVICELINES',
  request: {
    url: 'v2/analytics/providers/topservicelines',
    method: 'GET',
    params: {
      provider_id: options.providerId,
      limit: 3,
    },
  },
});

export const loadFavoriteLocations = (options) => ({
  storeId: 'favorite-locations-' + options.clientId,
  type: 'DASHBOARD_FAVORITE_LOCATIONS',
  request: {
    url: '/v2/my/locations/favorites',
    method: 'GET',
    params: {
      clientId: options.clientId,
    },
  },
});

export const loadFavoriteContacts = (options) => ({
  storeId: 'favorite-contacts-' + options.clientId,
  type: 'DASHBOARD_FAVORITE_CONTACTS',
  request: {
    url: '/v2/my/contacts/favorites',
    method: 'GET',
    params: {
      clientId: options.clientId,
    },
  },
});

export const loadLocationActivityNotes = (options) => ({
  storeId:
    'analytics-location-activitynotes-' +
    options.clientId +
    '-' +
    options.locationId,
  type: 'DASHBOARD_FAVORITE_LOCATION_ANALYTICS_ACTIVITY_NOTES',
  request: {
    url: 'v2/analytics/locations/totalactivitynotes',
    method: 'GET',
    params: {
      location_id: options.locationId,
      client_id: options.clientId,
    },
  },
});

export const loadLocationConnections = (options) => ({
  storeId:
    'analytics-location-connections-' +
    options.clientId +
    '-' +
    options.locationId,
  type: 'DASHBOARD_FAVORITE_LOCATION_ANALYTICS_CONNECTIONS',
  request: {
    url: 'v2/analytics/locations/connections',
    method: 'GET',
    params: {
      location_id: options.locationId,
      client_id: options.clientId,
    },
  },
});

export const loadContactActivityNotes = (options) => ({
  storeId: `analytics-contact-activitynotes-${options.clientId}-${options.contactId}`,
  type: 'DASHBOARD_FAVORITE_CONTACT_ANALYTICS_ACTIVITYNOTES',
  request: {
    url: 'v2/analytics/contacts/totalactivitynotes',
    method: 'GET',
    params: {
      contact_id: options.contactId,
      client_id: options.clientId,
    },
  },
});
